import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../base.service';



export class LicensedurationModel {
  id!: number;
  optionTitle!: string;
  duration!: number;
  isTrial!: boolean;
  isActive!: boolean;
  chargeDuration!: number;
}

@Injectable({
  providedIn: 'root'
})
export class LicensedurationsService {

  constructor(private http: HttpClient, private BaseService: BaseService) {}

  LicensedurationData: LicensedurationModel = new LicensedurationModel();

  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getLicensedurations() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/ProductLicenseDuration/GetAll', {
      headers,
    });
  }

  addLicenseduration(LicensedurationData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/ProductLicenseDuration/Add', LicensedurationData, {
      headers,
    });
  }

  editLicenseduration(LicensedurationData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/ProductLicenseDuration/Edit', LicensedurationData, {
      headers,
    });
  }

  deleteLicenseduration(id: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/ProductLicenseDuration/Delete/' + id, {
      headers,
    });
  }

  assignLicensedurationToProduct(LicensedurationData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/LicenseDurationAssigned/AssigntoProduct', LicensedurationData, {
      headers,
    });
  }

  getAssignedLicensedurationsByProductId(productId: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/LicenseDurationAssigned/GetDurationTypeByProductID/' + productId, {
      headers,
    });
  }
}
